import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import saveAs from 'file-saver';
import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const RenderAgencycsw = () => {

const resturl=sessionStorage.getItem("RESTURL");
let customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [modal, setModal] = useState({open:false});
const navWpform = React.useRef();
const [lbrclrdecsnexp, setLbrclrdecsnexp] = useState([]);
const [dowait, setDowait] = useState({on:false});

const [searchcrit, setSearchcrit] = useState({
	date1:''
	, date2:''
	});




const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if

document.title =   "APS LC Letters";	

if (lbrclrdecsnexp.length<1){
	getlbrclrdecsnexp();
	}//end if
	//qrylabor();
 },[]);




function handleChange(e){
	
	const {name, value}=e.target;
console.log("handleChange name: "+name+' '+value);

	setSearchcrit((prev)=>{
		return {...prev, [name]:value}	
	});
	
	//setSearchcrit({name:e.target.name, txt:e.target.value});
}//end if



async function getlbrclrLetter(e, LBR_CLR_APP_ID, DEC_ID, PDF_SIZE, FILE_PATH){

e.preventDefault();

//console.log("e.target.id: "+e.target.id);
if (!e.target.classList.contains("hidden"))
	e.target.classList.add("hidden");

if (1*PDF_SIZE==0)
	window.alert("The pdf letter may not have been generated as yet.\r\nIf it does not download you can try again after 10 minutes");



   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {LBR_CLR_APP_ID:LBR_CLR_APP_ID, DEC_ID:DEC_ID, PDF_SIZE:PDF_SIZE, FILE_PATH:FILE_PATH} )
  };		

  await fetch(resturl+'rarwptprocess/getlbrclrLetter',requestOptions)
      .then(res => 	aftergetlbrclrLetter(res, e, LBR_CLR_APP_ID) )
      .catch(err => console.log(err));

}//end func


async function aftergetlbrclrLetter(res, e, LBR_CLR_APP_ID){

if (e.target.classList.contains("hidden"))
	e.target.classList.remove("hidden");

const blob = await res.blob();
//const blobBytesSize = blob.size;
console.log("blob.type: "+blob.type);

if (blob.type=="application/json"){
	let blob_text = await blob.text();
	console.log("blob_text: "+blob_text);
	const temp = JSON.parse(blob_text);
	const error=temp?(temp.error??""):"seems the file was not found on the server ";
	alert(error);
	}
else
	saveAs(blob, "LabourClearanceLetter"+LBR_CLR_APP_ID+".pdf");

}//end func	
	
function nagivatetolbrclrapp(e, LBR_CLR_APP_ID){

e.preventDefault();
const confd=window.confirm("You will be navigated away from this page to Labour Clearance page.  Ok?");
if (!confd)
	return;
	
navigate("/lbr_clr_app", {state:{BACK_PAGE:"lbr_clr_letter", IPM_LBR_CLR_APP_ID:LBR_CLR_APP_ID}});	
	
}//end func

async function getlbrclrdecsnexp(){

let params = searchcrit;

console.log("getlbrclrdecsnexp: "+JSON.stringify(params));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
setLbrclrdecsnexp([]);

  await fetch(customspremurl+'rarwptapp/getlbrclrdecsnexp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetlbrclrdecsnexp(res) )
      .catch(err => console.log(err));

}//end func


function aftergetlbrclrdecsnexp(res){

if (!res.length)
	return;
	
let htmrows=[];

res.map((col, index) => {
	const trkey='tr_'+index;
	const rdkey='td_'+index;
	
	if (index==0)
		setSearchcrit({date1:col['DATE1'], date2:col['DATE2']});
	
	const comments = ""+col['DEC_COMMENTS'];
	const REVERSE_REASON = ""+col['REVERSE_REASON'];
	
	const htmrow=<tr key={trkey} >
	<td align='right' >{1+index}</td>
	<td align='left' >{col['APP_DEC_ID']}</td>
	<td align='left' >{col['LBR_CLR_APP_ID']}</td>
	<td align='left' >{col['DEC_ID']}</td>
	<td align='center' >{col['DEC_DATE']}</td>
	<td align='left' title={comments} >{comments.substring(0,18)}</td>
	<td align='center' >{col['REVERSE']}</td>
	<td align='left' title={REVERSE_REASON} >{REVERSE_REASON.substring(0,18)}</td>
	<td align='left' >{col['REVERSE_DT']}</td>
	<td align='left' >{col['REVERSE_COMMENTS']}</td>
	<td align='left' >{col['CREATED_DATE']}</td>
	<td align='left' >{col['CREATED_BY']}</td>
	</tr>;
	htmrows.push(htmrow);




});	

setLbrclrdecsnexp(htmrows);	
}//end func



function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func



function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;

if (!document.getElementById("btnsave").classList.contains("hidden"))
	document.getElementById("btnsave").classList.add("hidden");
		
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func




	
	

  return (
    <>
	<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >
	Exported Labour Clearance Decisions
	</p>
	<div align="center "style={{marginTop:"12px"}}  >
	<input name="date1" type="date" value={searchcrit.date1} onChange={(e)=>{handleChange(e);}} />&nbsp;&nbsp;
	<input name="date2" type="date" value={searchcrit.date2} onChange={(e)=>{handleChange(e);}} />&nbsp;&nbsp;
	<button className="button" onClick={(e)=>{getlbrclrdecsnexp();}} >apply date filter</button>
	</div>
	<table align='center' className='customers' style={{marginTop:"12px",width:"95%"}} >
	<thead>
	<tr>
		<th>#</th>
		<th>App Dec Id</th>
		<th>LC Id #</th>
		<th>Dec Id</th>
		<th>Dec Date</th>
		<th>Dec Comments</th>
		<th>Reversed</th>
		<th>Reverse Reason</th>
		<th>Reverse Date</th>
		<th>Reverse Comments</th>
		<th>Created Dt</th>
		<th>Created By</th>
	</tr>
	</thead>
	<tbody>
		{lbrclrdecsnexp}
	</tbody>
	</table>



<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button"  >&times;</span>
        <div align='center' id='modalsmtext' >
			
		</div>
    </div>
</div>
<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default RenderAgencycsw;